import React from "react";
import { useState } from "react";
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from "./ProjectsStyle";
import ProjectCard from "../Cards/ProjectCards";
import { projects } from "../../data/constants";

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState("all");
  return (
    <Container id="projects">
      <Wrapper>
        <Title>Projects</Title>
        <Desc>I have worked on a wide range of projects. From Artificial Intelligence to Android Application. Here are some of my projects.</Desc>
        <ToggleButtonGroup>
          {toggle === "all" ? (
            <ToggleButton active value="all" onClick={() => setToggle("all")}>
              All
            </ToggleButton>
          ) : (
            <ToggleButton value="all" onClick={() => setToggle("all")}>
              All
            </ToggleButton>
          )}
          <Divider />
          {toggle === "ai" ? (
            <ToggleButton active value="ai" onClick={() => setToggle("ai")}>
              Artificial Intelligence
            </ToggleButton>
          ) : (
            <ToggleButton value="ai" onClick={() => setToggle("ai")}>
              Artificial Intelligence
            </ToggleButton>
          )}
          <Divider />
          {toggle === "bi" ? (
            <ToggleButton active value="bi" onClick={() => setToggle("bi")}>
              Business Intelligence
            </ToggleButton>
          ) : (
            <ToggleButton value="bi" onClick={() => setToggle("bi")}>
              Business Intelligence
            </ToggleButton>
          )}
          <Divider />
          {toggle === "excel" ? (
            <ToggleButton active value="excel" onClick={() => setToggle("excel")}>
              Excel
            </ToggleButton>
          ) : (
            <ToggleButton value="excel" onClick={() => setToggle("excel")}>
              Excel
            </ToggleButton>
          )}
          <Divider />
          {toggle === "db" ? (
            <ToggleButton active value="db" onClick={() => setToggle("db")}>
              Database
            </ToggleButton>
          ) : (
            <ToggleButton value="db" onClick={() => setToggle("db")}>
              Database
            </ToggleButton>
          )}
          <Divider />
          {toggle === "web" ? (
            <ToggleButton active value="web" onClick={() => setToggle("web")}>
              Website
            </ToggleButton>
          ) : (
            <ToggleButton value="web" onClick={() => setToggle("web")}>
              Website
            </ToggleButton>
          )}
          <Divider />
          {toggle === "android" ? (
            <ToggleButton active value="android" onClick={() => setToggle("android")}>
              Android
            </ToggleButton>
          ) : (
            <ToggleButton value="android" onClick={() => setToggle("android")}>
              Android
            </ToggleButton>
          )}
        </ToggleButtonGroup>
        <CardContainer>
          {toggle === "all" && projects.map((project) => <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal} />)}
          {projects
            .filter((item) => item.category === toggle)
            .map((project) => (
              <ProjectCard project={project} openModal={openModal} setOpenModal={setOpenModal} />
            ))}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;
